import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"
import shuffle from "utils/shuffle"
import JobModel from "../models/job"

const useCollectionJobs = ({ type, order, limit } = {}) => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`
    query AllCollectionJobsQuery {
      jobs: allCollectionJobs(sort: { date: DESC }) {
        nodes {
          id
          order
          date
          locale
          url
          title
          occupancyRate
          duration
          typeOfDuration {
            value
          }
          type: jobType {
            slug
            title
          }
        }
      }
    }
  `)

  /**
   * Get all Jobs in the current locale
   * and apply filters if needed
   */
  return React.useMemo(() => {
    let jobs = data.jobs.nodes.filter(n => n.locale === locale)

    switch (order) {
      case "listOrder":
        jobs.sort((a, b) => a.order - b.order)
        break

      case "random":
        jobs = shuffle(jobs)
        break

      case "oldest":
        jobs.sort((a, b) => new Date(a.date) - new Date(b.date))
        break

      case "latest":
      default:
      // nothing to do, this is the natural order
    }

    if (limit) {
      jobs = jobs.slice(0, limit)
    }

    if (type) {
      jobs = jobs.filter(
        item => item.type && item.type.some(c => c.slug === type)
      )
    }

    return jobs.map(job => new JobModel(job))
  }, [data, locale, type, limit, order])
}

export default useCollectionJobs
